import React, { memo } from 'react';
import { Icon } from '@iconify/react';
import mdiBarcodeIcon from '@iconify/icons-mdi/barcode';

const BarcodeIcon = memo(() => {
  return <Icon icon={mdiBarcodeIcon} width="1.8em" height="1.8em" />;
});

export default BarcodeIcon;
